import { Delete, Tabs } from "../shared";
import ViewEmbedJS from "./ViewEmbedJS";
import UpdateEmbedJS from "./UpdateEmbedJS";
import PublishStatus from "./PublishStatus";
import { DELETE_EMBED_JS } from "./query";

const SubComponent = ({ data }) => {
    const { id, publishStatus } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `view-${id}`,
                    name: "View Embed JS",
                    content: <ViewEmbedJS data={data} />,
                },
                {
                    id: `update-${id}`,
                    name: "Update Embed JS",
                    content: <UpdateEmbedJS data={data} />,
                },
                {
                    id: `publish-${id}`,
                    name: "Update Publish Status",
                    content: <PublishStatus id={id} publishStatus={publishStatus} />,
                },
                {
                    id: `delete-${id}`,
                    name: "Delete Embed JS",
                    content: (
                        <Delete
                            id={id}
                            title="Embed JS"
                            query={DELETE_EMBED_JS}
                            cacheName="allAbbvieProEmbedJsSnippets"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
